/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  /**
   * Модель для чекбокса в фильтрах.
   */
  'use strict';
  app.Filters.Checkbox = app.Model.extend({
    defaults: {
      object: false,
      element: false,
      value: false,
      view: null
    },
    viewClass: app.Filters.CheckboxView,
    withoutView: false,
    additionalOptions: ['withoutView'],
    /**
     * @inheritDoc
     */
    run: function () {
      var object = this.get('object'),
      color = object.option_color;
      this.set('value', object.selected);
      if (color) {
        if (color[0] === '#') {
          object.style_color = color;
        } else {
          object.icon_name = color;
        }
      }
      if (!this.withoutView) {
        this.initView(object);
      }
    },

    /**
     * Инициализация вида.
     * @param {Object} object - обьект фильтра.
     */
    initView: function (object) {
      this.view = new this.viewClass({
        model: this,
        object: object,
        parent: this.get('element'),
        className: this.get('className')
      });
    },

    toQuery: function (obj) {
      if (this.get('value') && this.get('object').selectable) {
        obj.push(String(this.get('object').name));
      }
      return obj;
    }
  });
})();

}.call(window));